import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import dayjs from "dayjs";

const EditEventModal = ({
  open,
  onClose,
  onSave,
  onDelete,
  eventData,
  setEventData,
}) => {
  const handleChange = (field, value) => {
    setEventData((prev) => ({
      ...prev,
      [field]: value ? new Date(value) : null,
    }));
  };

  const modalCardSx = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "92%", sm: 520 },
    maxHeight: "90vh",
    overflowY: "auto",
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(10px)",
    borderRadius: "18px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    overflow: "hidden",
    outline: "none",
  };

  const fieldSx = {
    mt: 1.25,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255,255,255,0.96)",
      borderRadius: "10px",
    },
  };

  const primaryButtonSx = {
    backgroundColor: "#2f63ad",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1f4f94",
      boxShadow: "none",
    },
  };

  const secondaryButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
  };

  const deleteButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 700,
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="edit-event-modal">
      <Box sx={modalCardSx}>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: "1.35rem",
            pt: 3,
            pb: 1,
            color: "#1f1f1f",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Edit Event
          </Typography>
        </Box>

        <Box sx={{ px: 3, pb: 1 }}>
          <Typography
            sx={{
              mt: 0.5,
              mb: 1,
              textAlign: "center",
              color: "#666",
              fontSize: "0.95rem",
            }}
          >
            Update the event details below.
          </Typography>

          <TextField
            fullWidth
            label="Event Title"
            value={eventData?.title || ""}
            onChange={(e) =>
              setEventData((prev) => ({ ...prev, title: e.target.value }))
            }
            sx={fieldSx}
          />

          <Typography
            variant="body2"
            sx={{
              mt: 2,
              mb: 0.75,
              color: "#6b778c",
              fontWeight: 500,
            }}
          >
            Current Start Time:{" "}
            {eventData?.start
              ? new Date(eventData.start).toLocaleString()
              : "N/A"}
          </Typography>

          <TextField
            fullWidth
            type="datetime-local"
            label="Update Start Time"
            value={
              eventData?.start
                ? dayjs(eventData.start).format("YYYY-MM-DDTHH:mm")
                : ""
            }
            onChange={(e) => handleChange("start", e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={fieldSx}
          />

          <Typography
            variant="body2"
            sx={{
              mt: 2,
              mb: 0.75,
              color: "#6b778c",
              fontWeight: 500,
            }}
          >
            Current End Time:{" "}
            {eventData?.end
              ? new Date(eventData.end).toLocaleString()
              : "N/A"}
          </Typography>

          <TextField
            fullWidth
            type="datetime-local"
            label="Update End Time"
            value={
              eventData?.end
                ? dayjs(eventData.end).format("YYYY-MM-DDTHH:mm")
                : ""
            }
            onChange={(e) => handleChange("end", e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={fieldSx}
          />

          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Description / Meeting Info"
            value={eventData?.description || ""}
            onChange={(e) =>
              setEventData((prev) => ({ ...prev, description: e.target.value }))
            }
            sx={fieldSx}
          />

          <Box
            sx={{
              mt: 2,
              px: 1.25,
              py: 1.1,
              borderRadius: "12px",
              backgroundColor: "rgba(47,99,173,0.04)",
              border: "1px solid rgba(47,99,173,0.08)",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Created By: {eventData?.created_by_user_id || "N/A"}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            px: 3,
            pb: 3,
            pt: 1.5,
            display: "flex",
            justifyContent: "center",
            gap: 1.25,
            flexWrap: "wrap",
          }}
        >
          <Button onClick={onClose} variant="outlined" sx={secondaryButtonSx}>
            Cancel
          </Button>

          <Button onClick={onSave} variant="contained" sx={primaryButtonSx}>
            Save Changes
          </Button>

          <Button onClick={onDelete} variant="outlined" color="error" sx={deleteButtonSx}>
            Delete Event
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditEventModal;